<template>
  <div class="slide">
    <Tooltip title="Din alder">
      Din alder
    </Tooltip>
    <div class="grid-container">
      <div class="grid-x">
        <div class="small-12 cell">
          <label for="age"
            ><button></button>

            <input
              type="range"
              name="age"
              min="18"
              max="99"
              value="70"
              class="js--fancyrange"
              id="age"
              :data-gender="sex"
              v-model="age"
            />

            <input
              type="number"
              name="age"
              min="0"
              autocomplete="off"
              class="js--fancyrange__input fancyrange__input"
              id="age"
              v-model="age"
            />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    var $el = jQuery(".js--fancyrange").first();
    var value = $el.val();
    var min = $el.attr("min");
    var max = $el.attr("max");
    var percentage = ((value - min) / (max - min)) * 100;
    var $wrapper = jQuery('<div class="fancyrange"></div>');
    var $ranger = jQuery('<div class="fancyrange__ranger"></div>');
    var $dragger = jQuery(
      '<div class="fancyrange__dragger js--fancyrange__dragger"></div>'
    );
    var $input = $el.next(".js--fancyrange__input");
    var $inputWrapper = jQuery('<div class="fancyrange__inputWrapper"></div>');
    var $icon = jQuery('<div class="fancyrange__icon"></div>');

    $input.addClass("fancyrange__input");
    $inputWrapper.append($input);
    $inputWrapper.append('<span class="fancyrange__label">år</span>');
    $ranger.append(
      '<div class="fancyrange__active js--fancyrange__active" style="width: ' +
        percentage +
        '%;"></div>'
    );
    $dragger.append($inputWrapper);
    $dragger.append($icon);
    $dragger.css("left", percentage + "%");

    $el.wrap($wrapper);
    $el.closest(".fancyrange").append($ranger);
    $el.closest(".fancyrange").append($dragger);
    $el
      .closest(".fancyrange")
      .append(
        '<span class="fancyrange__num fancyrange__min">' + min + " år</span>"
      );
    $el
      .closest(".fancyrange")
      .append(
        '<span class="fancyrange__num fancyrange__max">' + max + " år</span>"
      );

    this.$store.commit("setAge", { age: value });

    setTimeout(() => {
      $el.change();
    }, 10);
  },

  computed: {
    sex: {
      get() {
        return this.$store.state.sex;
      },
    },
    age: {
      get() {
        return this.$store.state.age;
      },
      set(value) {
        this.$store.commit("setAge", { age: value });
      },
    },
  },
};
</script>
<style lang="scss">
.tooltip {
  display: none !important;
}
@media screen and (max-width: 639px) {
  .fancyrange__inputWrapper {
    font-size: 1rem;
  }
  .js--fancyrange__input,
  .fancyrange__label {
    font-size: 16px;
  }
}
.fancyrange__input {
  text-align: right;
  padding-right: 4px;
}
</style>
